import { CALL_STATE } from '../types';

const suspend = <T>(promise: Promise<T>): { read: () => T } => {
  let status: CALL_STATE = CALL_STATE.LOADING;
  let result: T;
  const suspender = promise.then(
    (r) => {
      status = CALL_STATE.LOADED;
      result = r;
    },
    (e) => {
      status = CALL_STATE.ERROR;
      result = e;
    },
  );

  return {
    read(): T {
      if (status === CALL_STATE.LOADING) {
        throw suspender;
      } else if (status === CALL_STATE.ERROR) {
        throw result;
      }

      return result;
    },
  };
};

const initializeDataReader = <T>(apiFn: () => Promise<T>): { read(): T } => {
  const subServicesPromise = apiFn();

  return suspend(subServicesPromise);
};

export default initializeDataReader;
